import { Link2, Calendar, Globe, Mail, Phone, MapPin, FileText, ShoppingBag, Star, MessageCircle, Image as ImageIcon, Video, Download, Heart, Briefcase, Info } from "lucide-react";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaTiktok, FaYoutube, FaPinterestP, FaWhatsapp } from "react-icons/fa6";

export const LINK_ICONS = {
  link: { label: "Link", Icon: Link2 },
  calendar: { label: "Calendario", Icon: Calendar },
  globe: { label: "Sito", Icon: Globe },
  mail: { label: "Email", Icon: Mail },
  phone: { label: "Telefono", Icon: Phone },
  "map-pin": { label: "Mappa", Icon: MapPin },
  "file-text": { label: "Documento", Icon: FileText },
  "shopping-bag": { label: "Shop", Icon: ShoppingBag },
  star: { label: "Stella", Icon: Star },
  "message-circle": { label: "Messaggio", Icon: MessageCircle },
  image: { label: "Immagine", Icon: ImageIcon },
  video: { label: "Video", Icon: Video },
  download: { label: "Download", Icon: Download },
  heart: { label: "Cuore", Icon: Heart },
  briefcase: { label: "Lavoro", Icon: Briefcase },
  info: { label: "Info", Icon: Info },
  whatsapp: { label: "WhatsApp", Icon: FaWhatsapp },
  instagram: { label: "Instagram", Icon: FaInstagram },
};

export const SOCIAL_ICONS = {
  instagram: FaInstagram,
  facebook: FaFacebookF,
  linkedin: FaLinkedinIn,
  tiktok: FaTiktok,
  youtube: FaYoutube,
  pinterest: FaPinterestP,
};

export const LinkIcon = ({ name, className, style }) => {
  const I = (LINK_ICONS[name] || LINK_ICONS.link).Icon;
  return <I className={className} style={style} strokeWidth={1.6} />;
};

export { FaWhatsapp };
